import styled from "@emotion/styled";
import { FC } from "react";

import { DesignToken, Heading } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

interface IProps {
  title: string;
  testId?: string;
}
export const AutomationsSectionHeader: FC<IProps> = ({ title, testId }) => (
  <StyledHeading size="xs" as="h2" data-testid={testId}>
    {title}
  </StyledHeading>
);

export const StyledHeading = styled(Heading)`
  padding-bottom: 5px;
  border-bottom: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};
`;
